/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */
'use strict';

import React from 'external/react';
import { AppContext, DataLinkContainer, DataNames as LrDataNames } from 'plugin/liferay-widgets-react-web';
import { getMapConfigStore, Map, MapWidget } from 'plugin/map-portlet';
import { getPageSelectedStore } from '../stores/StoreFactory';

const MapC = DataLinkContainer.link(Map, {
    selectedItems: getPageSelectedStore(AppContext),
    mapConfig: getMapConfigStore(AppContext)
});

class FliwasMapWidget extends MapWidget {

    renderPortlet(config){
        return (
            <MapC
                style={{ height: config.height + 'px' }}
                selectedItems={LrDataNames.PAGE_SELECTED}
                mapConfig={this.DATA.SELECTED_MAP_CONFIG}
                portletConfig={config}
                mapKey={this.MAP_ID}
            />
        );
    }
}

export default FliwasMapWidget;



// WEBPACK FOOTER //
// ./js/widgets/FliwasMapWidget.jsx